const user = "/user";
const info = "/info";

export const PATH = {
  home: "/",
  login: "/login",
  register: "/register",
  recovery: "/recovery",
  tournamentsPage: "/tournaments",
  bonusPage: "/bonus",
  newsPage: "/news",
  subGamePage: "/:categoryId/:providerId",
  gamePage: "/:categoryId",
  gameSlotsPage: "/slots",
  gameESportPage: "/e-sport",
  gameLivePage: "/live-casino",
  gameSportPage: "/sport",
  gameBoardGamePage: "/board-game",
  gameCockFighting: "/cock-fighting",
  user: {
    index: user,
    profile: user + "/profile",
    account: user + "/accounts",
    bonusHistory: user + "/bonus-history",
    bonusDetail: user + "/bonus-detail/:id",
    transactionHistory: user + "/transaction-history",
    documents: user + "/documents",
    myBonus: user + "/my-bonus",
    deposit: user + "/deposit",
    cashWithdraw: user + "/cash-withdraw",
    bank: user + "/banks",
    messages: user + "/messages",
    tournaments: user + "/tournaments",
    notFound: user + "/*",
    loyaltyProgram: user + "/member-vip",
    referral: user + "/referral",
  },
  info: {
    wager: info + "/wager",
    infoLoyaltyProgram: info + "/loyalty-program",
    growpay: info + "/growpay-payments",
    upi: info + "/upi",
    upiRegistration: info + "/upi-registration",
    depositInstructions: info + "/deposit-instruction",
    withdrawalInstructions: info + "/withdrawal-instruction",
    howToChoose: info + "/casino-table-games-how-to-choose",
    paymentWithdrawalMethods: info + "/payment-withdrawal-methods",
    freeBets: info + "/free-bets-info",
    promoCodes: info + "/promo-codes",
    androidApp: info + "/androidapp",
    changeAccount: info + "/change-account",
    contactUs: info + "/contact-us",
    about: info + "/about",
    terms: info + "/terms",
    responsibleGaming: info + "/responsible-gaming",
    selfExclusionPolicy: info + "/self-exclusion-policy",
    kyc: info + "/kyc",
    bettingRules: info + "/betting-rules",
    faq: info + "/faq",
    privacy: info + "/privacy",
    instaPromoCode: info + "/insta-promo-code",
    sportsCashback: info + "/sports-cashback",
    multipleBonus: info + "/multiple-bonus",
    teenPattiLive: info + "/teen-patti-live",
    lightningRouletteLive: info + "/lightning-roulette-live",
    dragonTigerLive: info + "/dragon-tiger-live",
    crazyTimeLine: info + "/crazy-time-live",
    lightningDiceLive: info + "/lightning-dice-live",
    blackJackLive: info + "/blackjack-live",
    andarBabarLive: info + "/andar-bahar-live",
    blog: info + "/blog",
    blogDetail: info + "/blog/:blogId",
  },
};
